<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2021. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <div>
    <v-row no-gutters>
      <div
        v-if="
          statuses !== STATUSES.COMPLETED &&
          statuses !== STATUSES.SUCCESS &&
          statuses !== STATUSES.CREATED &&
          !errorStatus
        "
      >
        <span class="status-color-blue">{{ tableItem.progress }}</span>
        <span class="status-color-blue">%</span>
      </div>
      <v-row no-gutters>
        <span v-if="errorStatus" class="status-color-red pointer" @mouseover="openDialog = true">
          {{ $t('progressLinearStatus.FAILED') }}
        </span>
        <div v-if="errorStatus && message" @mouseleave="openDialog = false">
          <v-img
            :id="`iiotProgressLinearWithStatusFeedbackIcon_${id}`"
            :src="`/img/warning.svg`"
            max-height="15px"
            max-width="15px"
            class="ml-12 margin-top-2 pointer"
            @mouseover="openDialog = true"
          />
          <div class="tooltip">
            <div v-if="openDialog" class="tooltiptext pr-2 pl-2 cursor-icon">
              <p v-if="page === 'backup'" class="feedback-title-font mb-3 mt-1 ml-n1">
                {{ $t('vmBackups.errorFeedbackTitle') }}
              </p>
              <p v-else class="feedback-title-font mb-3 mt-1 ml-n1">
                {{
                  $t('deployDetails.errorFeedbackTitle', {
                    device: tableItem.device,
                  })
                }}
              </p>
              <p v-if="!!message" class="mb-1">
                <span class="opacity-5 feedback-text-color"> {{ $t('progressLinearStatus.message') }} </span
                ><span class="feedback-text-color">{{ message }}</span>
              </p>
              <p v-if="!!troubleshooting" class="mb-1">
                <span class="opacity-5 feedback-text-color"> {{ $t('progressLinearStatus.troubleshooting') }} </span
                ><span class="feedback-text-color">{{ troubleshooting }}</span>
              </p>
              <p v-if="!!timeOfError" class="mb-1">
                <span class="opacity-5 feedback-text-color"> {{ $t('progressLinearStatus.timeOfError') }} </span
                ><span class="feedback-text-color">{{ timeOfError }}</span>
              </p>
            </div>
          </div>
        </div>

        <span
          v-if="statuses === STATUSES.COMPLETED || statuses === STATUSES.SUCCESS || statuses === STATUSES.CREATED"
          class="status-color-green"
        >
          {{ $t('progressLinearStatus.DONE') }}
        </span>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { STATUSES } from './helpers/constants';

export default {
  props: {
    tableItem: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      STATUSES,
      message: '',
      troubleshooting: '',
      timeOfError: '',
      openDialog: false,
    };
  },
  computed: {
    statuses() {
      return this.tableItem.status.toUpperCase();
    },
    errorStatus() {
      return (
        this.statuses === STATUSES.ABORTED ||
        this.statuses === STATUSES.FAILED ||
        this.statuses === STATUSES.ERROR ||
        this.statuses === STATUSES.FAIL ||
        this.statuses === STATUSES.REJECTED
      );
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'tableItem.errorFeedback': function () {
      this.setMessage();
    },
  },
  created() {
    this.setMessage();
  },
  methods: {
    setMessage() {
      if (this.page === 'deployLogDetails' && this.tableItem && this.tableItem.errorFeedback) {
        this.message = this.tableItem.errorFeedback.defautlMsg;
        this.troubleshooting = this.tableItem.errorFeedback.troubleshooting;
        if (this.tableItem.errorFeedback.timeOfFail) {
          this.timeOfError = new Date(this.tableItem.errorFeedback.timeOfFail).toLocaleString('en-GB');
        }
      }
      if (this.page === 'backup' && this.tableItem) {
        this.message = this.tableItem.error;
        if (this.tableItem.timeOfError) {
          this.timeOfError = this.tableItem.timeOfError.toLocaleString('en-GB');
        }
      }
      if (this.page === 'nodeUpdateDetails' && this.tableItem && this.tableItem.errorFeedback) {
        this.message = this.tableItem.errorFeedback.defautlMsg;
        this.troubleshooting = this.tableItem.errorFeedback.troubleshooting;
        if (this.tableItem.errorFeedback.timeOfFail) {
          this.timeOfError = new Date(this.tableItem.errorFeedback.timeOfFail).toLocaleString('en-GB');
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.status-color-red {
  color: #ff3d00;
}
.status-color-green {
  color: #44b384;
}
.status-color-blue {
  color: #0093d0;
}
.feedback-title-font {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
}
.opacity-5 {
  opacity: 0.5;
}
.v-tooltip__content {
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.15);
  background-color: #fff;
}
.feedback-text-color {
  color: #000000;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.margin-top-2 {
  margin-top: 2px;
}

.tooltip {
  position: absolute;
  z-index: 1;
}

.tooltip .tooltiptext {
  max-width: 950px;
  padding: 10px 10px 10px 10px;
  width: fit-content;
  white-space: pre-wrap;
  background-color: rgb(240, 243, 245);
  color: #fff;
  text-align: left;
  padding: 10px 0;
  opacity: 1;
  margin-top: 10px;
}

.tooltip .tooltiptext::after {
  position: bottom;
}

.cursor-icon {
  cursor: text;
}
.pointer {
  cursor: pointer;
}
</style>
